import { Button } from '@material-ui/core';
import React from 'react';
import { Helmet } from "react-helmet";
import { translate } from 'react-jhipster';
import { useHistory } from 'react-router';
import './not-found.scss';

const NotFound = () => {
  const history = useHistory();

  const handleBck = () => {

    history.push('/');
  }
  return (
    <>
      <Helmet>
        <title>404 Not Found</title>
        <meta name="description" content="Page not found" />
      </Helmet>
      <div className='not-found-content'>

        <img className="app-logo-loading" src="content/images/spb-loader-logo.png" alt="" />
        <h2>{translate(`settings.notFound[${"error"}]`)}</h2>
        <p>{translate(`settings.notFound[${"message"}]`)}</p>
        <Button variant="contained"
          className="btn"
          style={{ margin: '0.5rem' }}
          onClick={handleBck}
          disableElevation>
          {translate(`settings.notFound[${"back"}]`)}
        </Button>
      </div>
    </>
  );
};

export default NotFound;